import { useCurrentUserRegions } from "../hooks/useCurrentUserRegions.js";
// src/modules/AppWrapper2/components/IsMultiRegion.tsx
function IsMultiRegion({ children }) {
	const { availableRegions } = useCurrentUserRegions();
	if (availableRegions.length > 1) return children;
	return null;
}
export { IsMultiRegion };

//# sourceMappingURL=IsMultiRegion.js.map